import React from 'react';

const NotesPanel = ({ title, items }) => (
  <aside className="sm-notes">
    {title && <h3>{title}</h3>}
    {items.map((block) => (
      <section key={block.heading}>
        <h4>{block.heading}</h4>
        {block.body.map((p) => <p key={p.slice(0, 48)}>{p}</p>)}
        {block.list && (
          <ul>
            {block.list.map((li) => <li key={li.slice(0, 40)}>{li}</li>)}
          </ul>
        )}
      </section>
    ))}
  </aside>
);

export default NotesPanel;
